import { useNavigate } from 'react-router-dom';
import { PageBanner } from '../components';
import { Carousel3 } from '../images';

export const NotFound = () => {
    const navigate = useNavigate();

    return (
        // <div>
        //     <PageBanner image={Carousel3} title="404 Not Found" />
        // </div>
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100  flex-col items-center justify-center text-center">
            <PageBanner image={Carousel3} title="404 Not Found" />
            <div className="max-w-md mx-auto">
                {/* Error Message */}
                <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 my-6">
                    Oops! Page Not Found
                </h2>
                <p className="text-gray-600 mb-8">
                    The page you're looking for doesn't exist or has been moved.
                </p>

                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={() => navigate(-1)}
                        className="px-6 py-3 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-lg transition-colors"
                    >
                        Go Back
                    </button>
                    <button
                        onClick={() => navigate('/')}
                        className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
                    >
                        Return Home
                    </button>
                </div>
            </div>
        </div>
    );
};